
const handleAddBirthday = function(e, modal, id){
  e.preventDefault();

  // handle submission
  const monthField = modal.querySelector('[name="birthday-month"]');
  const dayField = modal.querySelector('[name="birthday-day"]');

  const day = dayField.value.length < 2 ? `0${dayField.value}` : dayField.value;
  const month = monthField.value.length < 2 ? `0${monthField.value}` : monthField.value;

  window.RivoJS.updateCustomerDob(`${month}-${day}`).then(function(success){
      if (success){
          const customActionUrl = `${window.Rivo.global_config.proxy_paths.loy}/loy/customers/${id}/record_custom_action`;
          fetch(customActionUrl, {
              method: "post",
              headers: new Headers({
                  Accept: "application/json",
                  "Content-Type": "application/json",
              }),
              body: JSON.stringify({
                  custom_action_name: "Add Birthday",
              }),
          });
      }
  })

  // update displayed information
  const oldMessage = modal.querySelector('.logged-in');
  const newMessage = modal.querySelector('.complete');
  const form = modal.querySelector('form');
  form.style.display = 'none';
  oldMessage.style.display = 'none';
  newMessage.style.display = 'block';
}

const toggleDisplay = function(elem, id){
  const message = elem.querySelector(id ? '.logged-in' : '.logged-out');
  const form = elem.querySelector('form');
  message.style.display = 'block';
  form.style.display = id ? 'flex' : 'none';
}

const initBirthdayModal = function(btn, modal){
  const overlay = modal.querySelector('.birthday__overlay');

  btn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.classList.add('active');
  });
  overlay.addEventListener('click', (e) => {
      e.preventDefault();
      modal.classList.remove('active');
  })
}

if (window.RivoJS) {
  const rivoCustomerId = window.Rivo && window.Rivo.common && window.Rivo.common.customer ? window.Rivo.common.customer.id : null;
  const birthdayButtons = document.querySelectorAll('[href="#trigger-birthday-add"]');
  const modal = document.querySelector('#birthday-modal-wrapper');
  const form = modal.querySelector('form');
  toggleDisplay(modal, rivoCustomerId);

  for (let i = 0; i < birthdayButtons.length; i += 1) {
      initBirthdayModal(birthdayButtons[i], modal, rivoCustomerId);
  }
  form.addEventListener('submit', (e) => {
      handleAddBirthday(e, modal, rivoCustomerId);
  })
} else {
  document.addEventListener("rivo-js-loaded", function(){
      const rivoCustomerId = window.Rivo && window.Rivo.common && window.Rivo.common.customer ? window.Rivo.common.customer.id : null;
      const birthdayButtons = document.querySelectorAll('[href="#trigger-birthday-add"]');
      const modal = document.querySelector('#birthday-modal-wrapper');
      const form = modal.querySelector('form');
      toggleDisplay(modal, rivoCustomerId);

      for (let i = 0; i < birthdayButtons.length; i += 1) {
          initBirthdayModal(birthdayButtons[i], modal, rivoCustomerId);
      }
      form.addEventListener('submit', (e) => {
          handleAddBirthday(e, modal, rivoCustomerId);
      })
  })
}